<template>
    <div>
       <backTitleBar :isBackHome="true"></backTitleBar>
        <div class="page-flex">
            <div class="page-data">
              <div>
                  <div class="page-text-d">设备状态</div>
              </div>
              <div id="myChart3" :style="{width: '10rem', height: '5rem' ,right:'2.8rem', bottom:'.48rem'}"></div>
            </div>

            <div class="page-data">
              <div>
                  <div class="page-text-d" style="margin-bottom: .48rem">设备使用占比</div>
              </div>
              <div id="myChart4" :style="{width: '7rem', height: '5rem' ,left:'.2rem', bottom:'.48rem'}"></div>
            </div>

            <div>
                  <div class="page-text-d">故障设备</div>
            </div>
            <div class="page-user">
               <div class="card">
                <div>
                    <div class="card-table-header">
                        <div class="table-index">设备名称</div>
                        <div class="table-main">唯一标识</div>
                        <div class="table-number">心跳时间</div>
                    </div>
                    <ul>
                        <li class="li-item" v-for="(item,$index) in shopList" :key="$index">
                            <div class="table-index">{{item.deviceName}}</div>
                            <div class="table-main">{{item.deviceId}}</div>
                            <div class="table-number">{{item.heartBeatTime}}</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div style="height: 0.95rem"></div>
          </div>
        </div>
        <tabber :tabActive="2"></tabber>
    </div>
</template>

<script>
    import routerBack from "@/mixins/routerBack"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryDeviceFaultRank, qryDeviceState, qryDeviceType} from "@/api/data"
    import tabber from '@/view/data/equipment/index'
    export default {
        name: "equipment",
        mixins: [routerBack],
        components:{tabber, backTitleBar},
        data(){
            return{
                modal1: false,
                tabTimeList:[
                    {name:'日',value: 1},
                    {name:'月',value: 2},
                    {name:'年',value: 3}
                ],
                tabTimeActive: 1,
                time:'',
                shopList: [],
                deviceState: [],
                deviceType: [],
                deviceStateName: [],
                deviceTypeName: [],
                deviceTypes: []           
            }
        },
        mounted(){
           let myDate = new Date();
           let time = myDate.toLocaleDateString().split('/').join('-');
           this.time = time;

          qryDeviceFaultRank().then(res=>{
               if(res.code == 0){
                  this.shopList = res.data.records
               }
           })

           qryDeviceState().then(res=>{
               if(res.code == 0){
                  let data = [];
                  let data2 = [];
                   res.data.records.forEach(param => {
                       data.push({name:param.deviceState,value:param.deviceNumber})
                       data2.push({name:param.deviceState})
                   });
                  this.deviceState = data
                  this.deviceStateName = data2
                  this.drawLine();
               }
           })

           qryDeviceType().then(res=>{
               if(res.code == 0){
                  let data = [];
                  let data2 = [];
                  let data3 = [];
                 res.data.records.forEach(param => {
                       data.push({name:param.deviceType,value:param.deviceNumber})
                       data2.push({name:param.deviceType})
                       data3.push({name:param.deviceType,value:param.deviceNumber,saleMoney:param.saleMoney})
                 });
                  this.deviceType = data
                  this.deviceTypeName = data2
                  this.deviceTypes = data3
                  this.drawLine();
               }
           })

           
           window.addEventListener('resize',()=>{
                this.$echarts.init(document.getElementById('myChart3')).resize()
                this.$echarts.init(document.getElementById('myChart4')).resize()
            })
        },
        methods: {
           timeChange(e){
             this.times = e;
           },
           check(){
               if(!this.times){
                   this.$Message.info('请选择日期');
                   return
               }
               this.time = this.times;
               this.modal1 = false
           },
           drawLine(){
               let _this = this;
           // 基于准备好的dom，初始化echarts实例
              let myChart = this.$echarts.init(document.getElementById('myChart3'));
              let myChart2 = this.$echarts.init(document.getElementById('myChart4'))
           // 绘制图表
               myChart.setOption({
                   tooltip: {
                     trigger: 'item',
                     formatter: "{a} <br/>{b}: {c} ({d}%)"
                   },
                  legend: {
                   orient: 'vertical',
                   top: 'center',
                   right: '5%',
                   icon: 'circle',
                   textStyle:{
                       fontSize: 16
                   },
                   formatter: function(name) {
                      // 获取legend显示内容
                      let data = _this.deviceState;
                      let total = 0;
                      let tarValue = 0;
                      for (let i = 0, l = data.length; i < l; i++) {
                                total += data[i].value;
                           if (data[i].name == name) {
                               tarValue = data[i].value;
                              }
                       }
                      let p = (tarValue / total * 100).toFixed(2);
                      return name + ' ' + ' ' + tarValue;
                   },
                   data: _this.deviceStateName
                  },
                  series: [
                    {
                     name:'设备状态',
                     type:'pie',
                     radius: ['50%', '70%'],
                     avoidLabelOverlap: false,
                       label: {
                         normal: {
                           show: false,
                           position: 'center'
                         },
                       emphasis: {
                         show: false,
                         textStyle: {
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                      }
                    },
                   labelLine: {
                        normal: {
                           show: false
                        }
                   },
                    data: _this.deviceState,
                    itemStyle: {
                      normal: {
                       color: function (params) {
                        var colorList = [
                          '#1FC581', '#FFB54F'
                         ];
                         return colorList[params.dataIndex]
                       }
                     }
                    }
                   }
                 ]
               });

               myChart2.setOption({
                   tooltip: {
                     trigger: 'item',
                     formatter: "{a} <br/>{b}: {c} ({d}%)"
                   },
                  legend: {
                   orient: 'vertical',
                   bottom: 0,
                   icon: 'circle',
                   textStyle:{
                       fontSize: 14
                   },
                   formatter: function(name) {
                      // 获取legend显示内容
                      let data = _this.deviceTypes;
                      let total = 0;
                      let tarValue = 0;
                      let saleMoney = 0;
                      for (let i = 0, l = data.length; i < l; i++) {
                                total += data[i].value;
                           if (data[i].name == name) {
                               tarValue = data[i].value;
                               saleMoney = data[i].saleMoney;
                              }
                       }
                      let p = (tarValue / total * 100).toFixed(2);
                      return name + ' ' + '设备数:' + ' ' + tarValue + ', ' + '总营销额:' + ' ' + saleMoney;
                   },
                   data: _this.deviceTypeName
                  },
                  series: [
                    { 
                     name:'设备使用占比',
                     type:'pie',
                     radius: ['40%','60%'],
                     center: ['50%','35%'],
                     avoidLabelOverlap: false,
                     label: {
                         normal: {
                           show: false,
                           position: 'center'
                         },
                       emphasis: {
                         show: false,
                         textStyle: {
                            fontSize: '30',
                            fontWeight: 'bold'
                          }
                        }
                      },
                      labelLine: {
                        normal: {
                           show: false
                         }
                       },
                      data: _this.deviceType,
                      itemStyle: {
                      normal: {
                       color: function (params) {
                        var colorList = [
                          '#1FC581', '#FFB54F','#4FAAFF'
                         ];
                         return colorList[params.dataIndex]
                       }
                     }
                    }
                   }
                 ]
               });
            //    window.addEventListener("resize", function () {
            //       setTimeout(function () {
            //         myChart3.resize();
            //         myChart4.resize();
            //       }, 500)
            //  });
            }
            
         }
    }
</script>

<style scoped lang="scss">
    .shop-top{
        display: flex;
        flex-direction: row;
        margin: .2rem 0;
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .05rem;
            margin-left: .4rem;
        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
    }
    .shop-info{
        padding-left: .6rem;
        padding-top: .37rem;
        padding-bottom: .32rem;
        display: flex;
        flex-direction: row;
        .zuori{
            font-size: .24rem;
            font-weight: 400;
            line-height: .47rem;
            width: 2.52rem;
            height: .47rem;
            background: rgba(0,0,0,0.1);
            border-radius: .27rem;
            margin-left: -.27rem;
            padding-left: .36rem;
        }
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .15rem;
            margin-left: .4rem;
           
        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
        .info-item{
            color: #fff;
            .title{
                color: #eee;
                font-size: .26rem;
                line-height: .4rem;
            }
            .number{
                padding-top: .11rem;
                font-size: .52rem;
            }
            &:first-child{
                width: 65%;
            }
            &:nth-child(2){
                width: 35%;
            }
        }
    }
    .page-flex{
        height: 100%;
        background: #fff;
        border-radius: .24rem;
        .page-data{
            background: #fff;
            height: 6rem;
            border-radius: .24rem;
        }
        .page-user{
            background: #fff;
            height: 4.9rem;
            border-radius: .24rem;
        }
        .datas{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding: .2rem .6rem;
            margin-top: .8rem;
        }
        .page-text-r{
            width: 2.2rem;
            height: .6rem;
            margin-top: .2rem;
            margin-left: 2.8rem;
            z-index: 9999;
        }
        .datas-text{
            margin-right: .4rem;
            margin-bottom: .1rem;
            flex: auto;
        }
        .datas-top{
           font-size: .4rem;
           font-weight: bold;
           color: #FD760C;
           text-align: center
        }
        .datas-bottom{
            font-size: .28rem;
            text-align: center
        }
        .page-text-d{
           float: left;
           font-size: .34rem;
           font-weight: bold;
           margin: .28rem .28rem;
           border-left: .04rem solid #1FC581;
           padding-left: .1rem;
        }
        .page-text-t{
           float: right;
           margin: .28rem .38rem;
           span{
               padding-left: .2rem;
           }
           span.active{
               color: #1FC581;
               font-weight: bold;
           }
        }
    }
    .page-data-time{
        display: block;
        margin: 0 auto;
    }
    .page-data-top{
        width: 94%;
        height: .68rem;
        display: flex;
        flex-direction: row;
        margin: .3rem .24rem;
        border-radius: .12rem;
        border: .03rem solid #1FC581;
    }
    .page-data-div{
        flex: auto;
        font-size: .28rem;
        text-align: center;
        line-height: .68rem;
        &:first-child{
          border-right: .03rem solid #1FC581;
        }
        &:nth-child(2){
          border-right: .03rem solid #1FC581;
        }
        &.active{
            color: #fff;
            background: #1FC581;
        }
    }
    .card{
        //width: 7rem;
        //margin: 0 .25rem;
        background: #fff;
        border-radius: .24rem;
        padding: .01rem .26rem;
        .card-title{
            font-size: .34rem;
            line-height: .48rem;
            color: #252D46;
            font-weight: bold;
        }
        .card-tab{
            display: flex;
            margin-top: .2rem;
            padding-bottom: .2rem;
            .tab-item{
                margin-right: .5rem;
                font-size: .3rem;
                line-height: .45rem;
                color: #919BA6;
                &.active{
                    position: relative;
                    color: #252D46;
                    &:after{
                        position: absolute;
                        content: '';
                        width: .82rem;
                        height: .06rem;
                        background: #83C221;
                        border-radius: .03rem;
                        bottom: -.15rem;
                        left: 0;
                    }
                }
            }
        }
    }
    .card-table-header{
        margin-top: .25rem;
        display: flex;
        background: #F5F6FA;
        border-radius: .14rem;
        padding: .16rem .2rem;
        font-size: .28rem;
        line-height: .4rem;
        color: #666;
    }
    .table-index{
        width: 2.6rem;
        margin-right: .2rem;
    }
    .table-main{
        flex: 1;
        margin-right: .1rem;
    }
    .table-number{
        width: 1.8rem;
    }
    .li-item{
        display: flex;
        font-size: .32rem;
        line-height: .45rem;
        color: #333;
        padding: .15rem .2rem;
        .table-index{
            color: #FF4242;
        }
    }
</style>



// WEBPACK FOOTER //
// equipment.vue?96325134